"use client";

import { Ref } from "react";

import Picture from "@/components/ui-kit/Picture/Picture";
import { cn } from "@/utils/general";

import styles from "./HomepageHero.module.scss";
import { HomepageHeroLifestage } from "./HomepageHero.types";

type HomepageHeroImagesProps = {
  images: Record<HomepageHeroLifestage, string>;
  imgRef: Ref<HTMLDivElement>;
  getFadeState: (key: HomepageHeroLifestage) => "fadeIn" | "fadeOut" | null;
};

const HomepageHeroImages = ({ images, imgRef, getFadeState }: HomepageHeroImagesProps) => (
  <div
    ref={imgRef}
    className={cn("mx-auto", styles.imageWrapper, styles.bgFilter, styles.filterThree)}
  >
    {(Object.keys(images) as HomepageHeroLifestage[]).map((key) => {
      const fade = getFadeState(key);
      return (
        <Picture
          key={key}
          src={images[key]}
          alt=""
          role="presentation"
          loading="eager"
          className={cn(fade === "fadeIn" && styles.fadeIn, fade === "fadeOut" && styles.fadeOut)}
        />
      );
    })}
  </div>
);

export default HomepageHeroImages;
